import * as React from 'react';
import ExitButton from 'components/button/ExitButton';
import YesNoButton from 'components/button/YesNoButton';
import { Box, Dialog, DialogActions, DialogContent, DialogTitle, Grid, Typography } from '@mui/material';

const ComptrollerConfirmModal = ({ showModal, setShowModal, setSubmitForm = () => {}, modalData, handleSubmit = () => {} }) => {
	const label = modalData?.label;
	let action = modalData?.activationStatus?.toLowerCase().replace(/_/g, ' ') ?? modalData?.action?.toLowerCase().replace(/_/g, ' ');

	const handleOk = () => {
		setSubmitForm(true);
		setShowModal(false);
		handleSubmit();
	};

	const handleClose = () => {
		setShowModal(false);
	};

	return (
		<React.Fragment>
			<Dialog
				keepMounted
				maxWidth={'xs'}
				fullWidth={true}
				open={showModal}
				onClose={handleClose}
				aria-labelledby="draggable-dialog-title"
				sx={{
					zIndex: 1600,
					// old: '& .MuiPaper-root': { borderRadius: '4px' }
					'& .MuiPaper-root': {
						borderRadius: '12px',
						border: '1px solid #E2E8F0',
						boxShadow: '0 18px 45px rgba(15, 23, 42, 0.24)',
						overflow: 'hidden',
					},
					'& .MuiBackdrop-root': {
						backgroundColor: 'rgba(15, 23, 42, 0.45)',
					},
				}}
			>
				<Box>
					<Grid
						container
						alignItems="center"
						justifyContent="space-between"
						sx={{
							height: '48px',
							bgcolor: '#F8FAFC',
							borderBottom: '1px solid #E2E8F0',
						}}
					>
						<Grid item>
							<DialogTitle sx={{ color: '#0F172A', display: 'flex', alignItems: 'center', padding: '0 24px' }}>
								{modalData?.head}
							</DialogTitle>
						</Grid>

						<Grid item sx={{ mr: 3 }}>
							<ExitButton handleClose={handleClose} color="#64748B" />
						</Grid>
					</Grid>

					<DialogContent sx={{ pt: { xs: 5.25, md: 10 }, pb: { xs: 4, md: 7 } }}>
						<Typography variant="h6" align="center">
							{label ? (React.isValidElement(label) ? label : `${label}`) : `Do you want to ${action}?`}
						</Typography>
					</DialogContent>

					<DialogActions sx={{ px: 3, pb: 3, display: 'flex', justifyContent: 'center' }}>
						<YesNoButton handleClick={handleOk} bgColor="#00914f" title="Yes" />
						<YesNoButton handleClick={handleClose} bgColor="#B00020" title="No" />
					</DialogActions>
				</Box>
			</Dialog>
		</React.Fragment>
	);
};

export default ComptrollerConfirmModal;
